import StartBlockPage, { StartBlockPageProps } from './StartBlockPage';

export type { StartBlockPageProps };
export default StartBlockPage;
